import { useSearchParams } from 'react-router-dom';
import { authorizationStore } from '../../../../modules/authorization/authorization.store';
import './styles.scss';
import { MouseEventHandler } from 'react';
import AuthSectionSwitch from '../../../authSectionSwitch';

export const TitlePiece: React.FC<{
  backButton?: { status: boolean; step: number };
  title: string;
  step: number;
  subtitle?: { text: string; navigation?: { text: string; url: string } };
  goTo: MouseEventHandler;
  typeofSection?: string;
  bottom?: boolean;
}> = ({
  title,
  step,
  subtitle,
  backButton,
  goTo,
  typeofSection,
  bottom = false,
}) => {
  const { back } = authorizationStore;
  const [searchParams, setSearchParams] = useSearchParams();

  const backTo = () => {
    if (backButton?.step === 0) {
      searchParams.set('auth', 'login');
      setSearchParams(searchParams, { replace: true });
    } else back(backButton?.step as number);
  };

  return (
    <div>
      <div className="authContinueTitleRow">
        {backButton?.status && (
          <div className="authGoBackIconCase" onClick={backTo}>
            <i className="icon-arrow-left" />
          </div>
        )}
        <p className="authPopupTitleText">{title}</p>
      </div>
      <AuthSectionSwitch
        goTo={goTo}
        subtitle={subtitle}
        typeofSection={typeofSection}
        bottom={bottom}
        step={step}
      />
    </div>
  );
};
